import React from 'react';
import Laptop from '../assets/laptop.png';
import { Link } from 'react-router-dom';

const Analytics = () => {
  return (
    <div className='w-full bg-white py-16 px-4'>
      <div className='max-w-[1240px] mx-auto grid md:grid-cols-2'>
        <img className='w-[500px] mx-auto my-4' src={Laptop} alt='/' />
        <div className='flex flex-col justify-center'>
          <p className='text-[#c88bc4] font-bold '>ML Development</p>
          <h1 className='md:text-4xl sm:text-3xl text-2xl font-bold py-2'>Data-Driven ML Lifecycle</h1>
          <p>
          Rapid's mission is to enable organizations to effectively manage their data and accelerate their artificial intelligence and machine learning efforts through our comprehensive, data-driven platform.
          </p>
          <Link to="/rasas">
          <button className='bg-black text-[#c88bc4] w-[200px] rounded-md font-medium my-6 mx-auto md:mx-0 py-3'>Get Started</button>
        </Link>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
